import {CampaignContentDesktop} from '@cohort/wallet/components/CampaignContentDesktop';
import useStoreContext from '@cohort/wallet/hooks/useStoreContext';
import StoreLeftPanel from '@cohort/wallet/layouts/store/StoreLeftPanel';
import StorePage from '@cohort/wallet/layouts/store/StorePage';
import React from 'react';

const CampaignPageDesktop: React.FC = () => {
  const {campaign} = useStoreContext();

  return (
    <StorePage
      title={campaign.collection.name}
      tracking={{
        namespace: 'store.campaign',
      }}
      leftPanel={<StoreLeftPanel withBuyButton />}
    >
      <CampaignContentDesktop campaign={campaign} />
    </StorePage>
  );
};

export default CampaignPageDesktop;
